import { ReactNode } from "react";

/* eslint-disable max-lines */
export const PermutiveEvents = {
  AdFavorite: "ad-favorite",
  AdPreview: "ad-preview",
};

export const EntityType = {
  PrivatePerson: 1,
  LegalEntity: 2
};

export const DetailGroupType = {
  valueWithTitle: "ValueWithTitle",
  valueOnly: "ValueOnly",
  textArea: "TextArea",
  map: "Map"
};

export const ControlType = {
  multiLevel: "MultiLevel",
  groupMultiLevel: "GroupMultiLevel",
  multiColorSelector: "MultiColorSelector",
  multiFieldSelector: "MultiFieldSelector",
  multiFieldSelectorCb: "MultiFieldSelectorCb",
  checkbox: "Checkbox",
  multiSelector: "MultiSelector",
  singleSelector: "SingleSelector",
  singleColorSelector: "SingleColorSelector",
  range: "Range",
  dropdown: "Dropdown",
  datePicker: "DatePicker",
  monthYearPicker: "MonthYearPicker",
  yearPicker: "YearPicker",
  inputText: "InputText",
  inputTextList: "InputTextList",
  money: "Money",
  switch: "Switch",
  photoUploader: "PhotoPicker",
  phones: "PhonePicker",
  singleOption: "SingleOption",
  year: "Year",
  monthYear: "MonthYear",
  date: "Date",
  map: "Map",
  radioSelector: "RadioSelector",
  horsePower: "HorsePower",
  tyres: "Tyres",
  suggestedTitle: "SuggestedTitle",
  inputLocation: "InputLocation",
  locationMultiSelect: "LocationMultiSelect",
  searchText: "text",
  suggestedAITitle: "SuggestedAITitle",
  suggestedAIDescription: "SuggestedAIDescription",
  timeInput: "TimeInput",
};

export const DetailValueType = {
  multiLevel: "MultiLevel",
  singleOption: "SingleOption",
  multiOptions: "MultiOptions",
  year: "Year",
  monthYear: "MonthYear",
  date: "Date",
  image: "Image",
  price: "Price",
  title: "Title",
  time: "Time",
  textList: "TextList",
};

export const InputType = {
  float: "Float",
  int: "Integer",
  boolean: "Boolean",
  text: "TextArea",
  string: "Text",
  date: "Date",
  month: "Month",
  year: "Year"
};

export const HelpingRoutes = {
  privacyPolicy: "zastita-osobnih-podataka",
  paymentMethods: "nacini-placanja",
  termsOfUse: "uvjeti-koristenja",
  advertising: "banner-oglasavanje",
  instructionsForUse: "pravila-za-predaju-oglasa",
  videoSetupInstructions: "upute-za-postavljanje-videa",
  faq: "faq",
  index: "https://www.index.hr"
};

export const ButtonType = {
  top: "top",
  bottom: "bottom"
};

export const AdType = {
  active: "Active",
  inActive: "InActive"
};

interface NotificationFrequencyInterface {
  value: number;
  name: string;
}

export const NotificationFrequency: NotificationFrequencyInterface[] = [
  { value: 2, name: "Dnevno" },
  { value: 3, name: "Tjedno" },
  { value: 4, name: "Nikad" }
];

export interface PhoneInterface {
  id?: string;
  userId: string;
  number: string;
  isForeignNumber: boolean;
  isPrimary: boolean;
  name?: string;
  isVerified?: boolean;
}

export const PhoneVerificationRequestStatus = {
  notVerified: 1,
  notAwseringPhone: 2,
  invalidPhoneNumber: 3,
  verified: 4
};

export interface PhoneVerificationRequestStatusTextInterface {
  name: string;
  value: number; //keyof typeof PhoneVerificationRequestStatus
}

export const PhoneVerificationRequestStatusText: PhoneVerificationRequestStatusTextInterface[] = [
  {
    name: "Neverificiran broj",
    value: PhoneVerificationRequestStatus.notVerified
  },
  {
    name: "Nije se javio",
    value: PhoneVerificationRequestStatus.notAwseringPhone
  },
  {
    name: "Neispravni broj",
    value: PhoneVerificationRequestStatus.invalidPhoneNumber
  },
  {
    name: "Verificiran broj",
    value: PhoneVerificationRequestStatus.verified
  }
];

export interface VerifyModalI {
  heading: string;
  content: string | ReactNode;
  redirectPath: string;
  okText?: string;
  cancelText?: string;
  noRedirect?: boolean;
  onClose?: () => void;
}

export const PaymentMethod = {
  creditCard: 0,
  storeCredit: 1,
  bankTransfer: 2
};

export const RealEstatePricesUserTypeValues = {
  ALL_USERS: 0,
  PRIVATE_USERS: 1,
  BUSINESS_USERS: 2,
}


export interface PaymentMethodTextInterface {
  name: string;
  value: number; //keyof typeof PaymentMethod
  description: string;
  state: string;
}

export const PaymentMethodText: PaymentMethodTextInterface[] = [
  {
    name: "Platnom karticom",
    value: PaymentMethod.creditCard,
    description: "Aktivno odmah",
    state: ""
  },
  {
    name: "Općom uplatnicom, internet bankarstvom",
    value: PaymentMethod.bankTransfer,
    description: "Aktivno za 1-3 radna dana",
    state: ""
  },
  {
    name: "Kreditom",
    value: PaymentMethod.storeCredit,
    description: "Aktivno odmah",
    state: "{0} kredita na stanju"
  }
];

export const ShoppingCartFormat = {
  invoices: 1,
  purchases: 2
}

export interface ShoppingCart {
  createdAt?: string;
  email?: string;
  id?: string;
  item: ShoppingCartItem;
  lastModifiedDate?: string;
  paymentMethod: number; //keyof typeof PaymentMethod
  referenceNumber?: string;
  status?: number; //keyof typeof ShoppingCartStatus
  userId?: string;
  userName?: string;
  invoiceId?: string;
  bankTransferInfo?: BankTransferInfo;
  startPage?: number;
}

export interface ShoppingCartList {
  data: ShoppingCart[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
  totalPrice: number;
}

export interface ShoppingCartListParsed {
  data: ShoppingCartParsed[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
}

export interface ShoppingCartParsed {
  createdAt: string;
  email?: string;
  id: string;
  name: string;
  adTitle: string | null;
  adUrl: string | null;
  paymentMethod?: number; //keyof typeof PaymentMethod
  status?: number; //keyof typeof ShoppingCartStatus
  userId?: string;
  userName?: string;
  referenceNumber?: string;
  invoiceId: string;
  priceWithoutVat: number;
  vat: number;
  price: number;
  bankTransferInfo?: BankTransferInfo;
  type: number; //keyof typeof ShoppingCartItemType
}

export interface ShoppingCartItem {
  adCode?: number;
  adId: string | null;
  adUrl?: string | null;
  adTitle?: string | null;
  itemId: string;
  name?: string;
  priceWithoutVat?: number;
  vat?: number;
  price?: number;
  type: number; //keyof typeof ShoppingCartItemType
}

export const ShoppingCartItemType = {
  StoreCredit: 0,
  Promotion: 1,
  AdAutoRenewal: 2,
  AutoPromotion: 3,
};

export const ShoppingCartStatus = {
  awaitingPayment: 0,
  awaitingCreditCardPayment: 1,
  completed: 2,
  cancelled: 3,
  failed: 4,
  refunded: 5
};

export interface ShoppingCartStatusTextInterface {
  value: number; //keyof typeof ShoppingCartStatus
  name: string;
}

export const ShoppingCartStatusText: ShoppingCartStatusTextInterface[] = [
  { value: ShoppingCartStatus.awaitingPayment, name: "Čeka plaćanje" },
  { value: ShoppingCartStatus.awaitingCreditCardPayment, name: "Čeka plaćanje kreditnom karticom" },
  { value: ShoppingCartStatus.completed, name: "Plaćeno" },
  { value: ShoppingCartStatus.cancelled, name: "Otkazano" },
  { value: ShoppingCartStatus.failed, name: "Neuspješno" },
  { value: ShoppingCartStatus.refunded, name: "Vraćeno" }
];

export interface CreditsLogParsed {
  adminId: string;
  adminEmail: string;
  createdAt: string;
  newBalance: number;
  oldBalance: number;
  addedBalance: string | number;
  reason: string;
  userId: string;
  email: string;
}

export interface CreditsLogListParsed {
  data: CreditsLogParsed[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
}

export interface CreditsLog {
  adminId: string;
  adminEmail: string;
  createdAt: string;
  newBalance: number;
  oldBalance: number;
  reason: string;
  userId: string;
  email: string;
}

export interface CreditsLogList {
  data: CreditsLog[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
}

export interface CreditCardInfoRedirectParameters {
  store_id: string;
  order_number: string;
  language: string;
  currency: string;
  amount: string;
  cart: string;
  version: string;
  signature: string;
  require_complete: string;
  redirect?: string;
}

export interface CreditCardInfo {
  merchantUrl: string;
  redirectParameters: CreditCardInfoRedirectParameters;
}

export interface BankTransferInfo {
  currency: string;
  value: string;
  recipientAccount: string;
  model: string;
  referenceNumber: string;
  description: string;
  recipient: string;
  purposeCode: string;
  barcode: string;
  swift: string;
}

export const BankTransferInfoColumns = {
  currency: "currency",
  value: "value",
  recipientAccount: "recipientAccount",
  model: "model",
  referenceNumber: "referenceNumber",
  description: "description",
  recipient: "recipient",
  purposeCode: "purposeCode",
  barcode: "barcode",
  swift: "swift"
};

interface BankTransferInfoTextInterface {
  label: string;
  value: string; //keyof typeof BankTransferInfoColumns
}

export const BankTransferInfoText: BankTransferInfoTextInterface[] = [
  {
    label: "IBAN ili broj računa primatelja",
    value: BankTransferInfoColumns.recipientAccount
  },
  {
    label: "Poziv na broj primatelja",
    value: BankTransferInfoColumns.referenceNumber
  },
  {
    label: "Primatelj",
    value: BankTransferInfoColumns.recipient
  },
  {
    label: "Iznos",
    value: BankTransferInfoColumns.value
  },
  {
    label: "Valuta",
    value: BankTransferInfoColumns.currency
  },
  {
    label: "Model",
    value: BankTransferInfoColumns.model
  },
  {
    label: "Opis plaćanja",
    value: BankTransferInfoColumns.description
  },
  {
    label: "BIC/SWIFT",
    value: BankTransferInfoColumns.swift
  },
  {
    label: "Šifra namjene",
    value: BankTransferInfoColumns.purposeCode
  },
  {
    label: "Barkod",
    value: BankTransferInfoColumns.barcode
  },
];

export interface ShoppingCartResponse {
  id: string;
  creditCardInfo?: CreditCardInfo;
  bankTransferInfo?: BankTransferInfo;
  paymentMethod: number; //keyof typeof PaymentMethod
  status: number; //keyof typeof ShoppingCartStatus
  type: number; //keyof typeof ShoppingCartItemType
}

// Admin Notes
export interface AdminNoteParsed {
  id: string;
  userId: string;
  userEmail: string;
  userName: string;
  note: string;
  entityId: string;
  createdAt: string;
  lastModifiedDate: string;
}

export interface AdminNotesListParsed {
  data: AdminNoteParsed[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
}

export interface AdminNote {
  id: string;
  userId: string;
  userEmail: string;
  userName: string;
  note: string;
  entityId: string;
  createdAt: string;
  lastModifiedDate: string;
}

export interface AdminNotesList {
  data: AdminNote[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
}

export interface AdminNoteRequest {
  id?: string;
  note: string;
  entityId: string;
}

export interface BlockReason {
  id: number;
  name: string;
}

export const BlockingDecisionBasedOn = {
  userReport: 1,
  internalCheck: 2,
};


export const AdsSortOption = {
  PriceAsc: 1,
  PriceDesc: 2,
  DateAsc: 3,
  DateDesc: 4,
  ViewAsc: 5,
  ViewDesc: 6,
  mostRelevant: 7
};

export const RatingSortOption = {
  Newest: 1,
  Oldest: 2,
  Highest: 3,
  Lowest: 4
};

interface AdsSortOptionTextInterface {
  name: string;
  value: number; //keyof typeof AdsSortOption
  iconId: string;
}

export const AdsSortOptionText: AdsSortOptionTextInterface[] = [
  {
    name: "S nižom cijenom",
    value: AdsSortOption.PriceAsc,
    iconId: "sortOptions/price-ascending.png"
  },
  {
    name: "S višom cijenom",
    value: AdsSortOption.PriceDesc,
    iconId: "sortOptions/price-descending.png"
  },
  {
    name: "Najstariji",
    value: AdsSortOption.DateAsc,
    iconId: "sortOptions/time-ascending.png"
  },
  {
    name: "Najnoviji",
    value: AdsSortOption.DateDesc,
    iconId: "sortOptions/time-descending.png"
  },
  {
    name: "Najrelevantniji",
    value: AdsSortOption.mostRelevant,
    iconId: "sortOptions/most-relevant.png"
  }
];

export const ApiCacheKey = {
  ad: 1,
  auth: 2,
  favorite: 3,
  savedSearch: 4,
  user: 5,
  category: 6,
  module: 7,
  suggestion: 8,
  resource: 9,
  agency: 10,
  model: 11,
  utils: 12,
  config: 13,
  routes: 14,
  promotion: 15,
  cart: 16,
  credits: 17,
  note: 18,
  AI: 20,
  phone: 19,
  rating: 21,
  makeModelInfo: 22,
};

export const MakeModelInfoStatus = {
  Draft: 0,
  Published: 1
};

export const MakeModelInfoStatusText = [
  { value: MakeModelInfoStatus.Draft, name: "Skica" },
  { value: MakeModelInfoStatus.Published, name: "Objavljeno" }
];

export const InputSize = {
  large: "large",
  default: "default",
  small: "small"
};

export const UserRole = {
  superAdmin: "SuperAdmin",
  admin: "Admin",
  member: "Member"
};

export const ModuleFormat = {
  Full: 1,
  NameOnly: 2
};

export const AdStatus = {
  all: 0,
  active: 1,
  paused: 2,
  sold: 3,
  deleted: 4,
  blocked: 5,
  expired: 6,
  expireSoon: 999,
};

// Client-only key for the "Duplikat" tab in the admin ad manager.
// Duplicates are not an ad status - they come from the /duplicate-ads endpoint -
// so this deliberately is not a member of AdStatus.
export const AD_DUPLICATE_TAB_KEY = "duplicate";

const AdFilterDateType = {
  createdAt: 1,
  renewalDate: 2,
  expirationDate: 3,
  promotionDate: 4,
  soldDate: 5,
  pausedDate: 6,
  deletedDate: 7
};

export interface AdFilterDateTypeTextInterface {
  name: string;
  value: number; //keyof typeof AdFilterDateType
}

export const AdFilterDateTypeText: AdFilterDateTypeTextInterface[] = [
  {
    name: "Datum kreiranja",
    value: AdFilterDateType.createdAt,
  },
  {
    name: "Datum obnove",
    value: AdFilterDateType.renewalDate,
  },
  {
    name: "Datum isteka",
    value: AdFilterDateType.expirationDate,
  },
  {
    name: "Datum isticanja",
    value: AdFilterDateType.promotionDate,
  },
  {
    name: "Datum prodaje",
    value: AdFilterDateType.soldDate,
  },
  {
    name: "Datum pauziranja",
    value: AdFilterDateType.pausedDate,
  },
  {
    name: "Datum brisanja",
    value: AdFilterDateType.deletedDate,
  }
];


export const AgencySyncStatus = {
  failed: 0,
  success: 1,
  pending: 2,
};

export const AdPromotionStatus = {
  inactive: 0,
  active: 1,
  auto: 2,
}

export const AdAutoPromotionStatus = {
  disabled: 0,
  enabled: 1
};

export const AdStatusHr = {
  svi: AdStatus.all,
  aktivan: AdStatus.active,
  pauziran: AdStatus.paused,
  prodano: AdStatus.sold,
  izbrisan: AdStatus.deleted,
  blokiran: AdStatus.blocked,
  istekao: AdStatus.expired,
  uskoroIstjece: AdStatus.expireSoon
};

interface AdReportReasonInterface {
  name: string;
  value: number;
}

export const AdReportReason: AdReportReasonInterface[] = [
  { name: "Prodano", value: 1 },
  { name: "Nema odgovora", value: 2 },
  { name: "Pogrešna kategorija", value: 3 },
  { name: "Dupli oglas", value: 4 },
  { name: "Neprimjeren sadržaj", value: 5 },
  { name: "Ostalo", value: 6 }
];

export const PostDeletionSurveyReason = {
  soldOnIndexOglasi: 1,
  soldOnOtherPlatform: 2,
  noLongerForSale: 3,
  other: 4,
  renewOrRecreateAd: 5,
  updatePricePhotosOrData: 6,
  adWasAddedByMistake: 7,
  // Keep the `NotEnoguh` typo verbatim from the BE enum — renaming would
  // break the numeric mapping shared with the API.
  notEnoguhInteraction: 8,
  temporarilyRemovingAds: 9,
};

interface PostDeletionSurveyReasonInterface {
  label: string;
  value: number; //keyof typeof PostDeletionSurveyReason
}

// Display order per ticket — numeric values aren't sequential because
// `other` (4) always sits last while the new options (5-9) slot between
// "Više nije dostupno..." (3) and it.
export const PostDeletionSurveyReasonOptions: PostDeletionSurveyReasonInterface[] = [
  { label: "Prodano preko Index Oglasa", value: PostDeletionSurveyReason.soldOnIndexOglasi },
  { label: "Prodano na drugom mjestu", value: PostDeletionSurveyReason.soldOnOtherPlatform },
  { label: "Više nije dostupno ili sam odustao/la od prodaje", value: PostDeletionSurveyReason.noLongerForSale },
  { label: "Želim obnoviti ili ponovno objaviti oglas", value: PostDeletionSurveyReason.renewOrRecreateAd },
  { label: "Želim promijeniti cijenu, fotografije ili podatke oglasa", value: PostDeletionSurveyReason.updatePricePhotosOrData },
  { label: "Oglas je objavljen pogrešno ili dvaput", value: PostDeletionSurveyReason.adWasAddedByMistake },
  { label: "Nije bilo dovoljno pregleda ili interesa", value: PostDeletionSurveyReason.notEnoguhInteraction },
  { label: "Privremeno povlačim oglas", value: PostDeletionSurveyReason.temporarilyRemovingAds },
  { label: "Nešto drugo", value: PostDeletionSurveyReason.other }
];

// The first two options (Prodano... preko/na drugom mjestu) get reworded
// based on category type: "Iznajmljeno" for rent categories, "Udomljeno"
// for adoption/pets. Other options stay the same.
const RENT_LABEL_OVERRIDES: { [value: number]: string } = {
  [PostDeletionSurveyReason.soldOnIndexOglasi]: "Iznajmljeno preko Index Oglasa",
  [PostDeletionSurveyReason.soldOnOtherPlatform]: "Iznajmljeno na drugom mjestu",
};

const ADOPTION_LABEL_OVERRIDES: { [value: number]: string } = {
  [PostDeletionSurveyReason.soldOnIndexOglasi]: "Udomljeno preko Index Oglasa",
  [PostDeletionSurveyReason.soldOnOtherPlatform]: "Udomljeno na drugom mjestu",
};

// Rent uses substring so any future `*-for-rent` / `najam-*` slug is
// picked up automatically, plus an explicit list for accommodation
// categories that are rent-by-nature but don't carry `rent`/`najam` in
// the slug. Adoption is exact-match on the single domination-and-giving
// / udomljavanje category — pets-for-sale and other animal categories
// should keep the default "Prodano" wording.
const RENT_CATEGORY_SLUGS = [
  "apartments-rooms-houses", "apartmani-sobe-kuce",
  "student-accommodation", "domski-studentski-smjestaj",
  "retirement-accommodation", "umirovljenicki-smjestaj",
];
const ADOPTION_CATEGORY_SLUGS = ["domination-and-giving", "udomljavanje"];

const getDeletionLabelOverrides = (category?: string) => {
  if (!category) return null;
  const c = category.toLowerCase();
  if (
    c.indexOf("rent") !== -1 ||
    c.indexOf("najam") !== -1 ||
    RENT_CATEGORY_SLUGS.indexOf(c) !== -1
  ) return RENT_LABEL_OVERRIDES;
  if (ADOPTION_CATEGORY_SLUGS.indexOf(c) !== -1) return ADOPTION_LABEL_OVERRIDES;
  return null;
};

export const getPostDeletionSurveyReasonOptions = (category?: string): PostDeletionSurveyReasonInterface[] => {
  const overrides = getDeletionLabelOverrides(category);
  if (!overrides) return PostDeletionSurveyReasonOptions;
  return PostDeletionSurveyReasonOptions.map(o =>
    overrides[o.value] ? { label: overrides[o.value], value: o.value } : o
  );
};

export const MobileOS = {
  android: "android",
  iOS: "iphone"
};

export const PageRoute = {
  home: "/",
  details: "/oglas",
  promote: "/istaknite-oglas",
  statistics: "/statistika",
  myAd: "/moji-oglasi",
  chats: "/poruke",
  credits: "/krediti",
  finance: "/financije",
  search: "/pretraga",
  savedSearch: "/spremljene-pretrage",
  postAd: "/novi-oglas",
  editAd: "/izmjena-oglasa",
  favorite: "/spremljeni-oglasi",
  myRatings: "/moje-ocjene",
  profile: "/moji-podaci",
  settings: "/postavke",
  changePassword: "/lozinka",
  help: "/pomoc",
  sub: "/sub",
  verifyEmail: "/verificiranje-korisnika",
  user: "/korisnik",
  userRatings: "/ocjene",
  realEstatePrices: "/cijene",
};


export const QueryParam = {
  searchQuery: "searchQuery",
  status: "status",
  page: "page",
}

export const HashTag = {
  adUpdated: "#adUpdated",
  adNew: "#adNew",
  adHide: "#adHide",
  adPromoted: "#adPromoted",
  adReport: "#adReport",
  creditPurchased: "#creditPurchased",
  contactAfterLogin: "#contactAfterLogin",
  focusPhone: "#focusPhone",
}

export const UserFormat = {
  public: 1,
  profile: 2
};

export const UserSearchFormat = {
  public: 1,
  profile: 2,
  manage: 3,
  username: 4
};

export const AdDetailFormat = {
  all: 1,
  summary: 2,
  favorite: 3
};

export const LocalStorageKey = {
  visitedAd: "VisitedAd", // pure value, not affected by auth state
  favorites: "Favorites", // transient value between auth login state
  savedForm: "SavedForm", // pure value, not affected by auth state //TODO: Davor : make it auth state affected value thats is cleared on logout
  recentSearches: "RecentSearches", // pure value, not affected by auth state
  recentSearchQuery: "RecentSearchQuery", // pure value, not affected by auth state 
  savedSearch: "SavedSearch", // transient value between auth login state
  redirectAfterCreditPurchase: "redirectAfterCreditPurchase", // transient value between auth login state
  disableAutoPromotionModal: "disableAutoPromotionModal", // pure value, not affected by auth state //TODO: Davor : make it auth state affected value thats is cleared on logout
  isAgeVerified: "isAgeVerified", // pure value, not affected by auth state
  posponedPostDeleteSurvey: "postponedPostDeleteSurvey", // pure value, not affected by auth state
  searchMode: "SearchMode", // pure value, not affected by auth state
  wasDiscountPromoShown: "wasDiscountPromoShown", // used for showing tooltip for discount promo on my ads card
  pendingFollowStore: "PendingFollowStore", // transient value between auth login state
  realEstatePricesSelection: "RealEstatePricesSelection", // session only, remembers selection on back navigation
  lastClickedSearchAd: "LastClickedSearchAd", // one-shot value, consumed on return to the search results
  pollPopupDismissals: "PollPopupDismissals", // pure value, per poll: consecutive X dismissals and how long to stay quiet
};

export const SearchMode = {
  ai: "ai",
  classic: "classic",

};

export const ScreenSize = {
  tiny: 320,
  small: 576,
  medium: 768,
  large: 992,
  extraLarge: 1200,
  detailPageSwitchLayout: 1340,
  extraExtraLarge: 1600,
  fullHD: 1920
};

export const DataSource = {
  location: "location",
  make: "make",
  others: "subcategories",
  // Value still used by the UI config JSON files (form.json, advancedSearch.json, ...)
  // for the subcategory controls. Compare through isSubcategoryDataSource().
  legacyOthers: "multilevelsource"
};

export const isSubcategoryDataSource = (dataSource: string) =>
  dataSource === DataSource.others || dataSource === DataSource.legacyOthers;

// Location tree levels as returned by configuration/locations endpoints.
export const LocationLevel = {
  country: 0,
  county: 1,
  city: 2,
  settlement: 3
};

// Multi level datasets: ad fields and search query fields per level.
// Replaces lvField / lvSearchField previously returned by the datasource endpoint.
export const MultiLevelFields = {
  subcategories: {
    fields: ["categoryLv1Id", "categoryLv2Id"],
    searchFields: ["categoryLv1Ids", "categoryLv2Ids"]
  },
  make: {
    fields: ["makeId", "modelId"],
    searchFields: ["includeMakeIds", "includeModelIds"]
  },
  location: {
    fields: ["countryId", "countyId", "cityId", "settlementId"],
    searchFields: [
      "includeCountryIds",
      "includeCountyIds",
      "includeCityIds",
      "includeSettlementIds"
    ]
  }
};

export const getMultiLevelFields = (dataSource: string) =>
  dataSource === DataSource.make
    ? MultiLevelFields.make
    : dataSource === DataSource.location
      ? MultiLevelFields.location
      : MultiLevelFields.subcategories;

// Search parameter per location level (index = LocationLevel).
export const LocationSearchFieldByLevel = MultiLevelFields.location.searchFields;
export const LocationFieldByLevel = MultiLevelFields.location.fields;

export const ImportMappingType = [
  {
    name: "Njuskalo - Auto-Moto",
    value: 1
  },
  {
    name: "Njuškalo - Nekretnine",
    value: 2
  },
  {
    name: "Dimedia - Nekretnine",
    value: 3
  },
  {
    name: "Adriatic - Apartmani, sobe, kuće",
    value: 4
  },
  {
    name: "Njuškalo - Ostalo",
    value: 5
  },
  {
    name: "Njuškalo - Jednostavan",
    value: 6
  },
  {
    name: "Dječji svijet",
    value: 7
  },
  {
    name: "Index - Webshop",
    value: 8
  }
];

export const START_PAGE_PARAM = "startPage"
export const PromotionFromPages = {
  MyAds: 1,
  Search: 2,
  SingleAd: 3,
  AdStatistics: 4,
  AdCreated: 5,
  AdUpdated: 6,
  Effects: 7
}

export const LocaleCode = {
  en: "en",
  hr: "hr"
};

export const ModuleName = {
  vehicles: "vehicles",
  realEstate: "real-estate",
  tourism: "tourism",
  jobs: "jobs",
  machinesAndTools: "machines-and-tools",
  allForHome: "all-for-home",
  animals: "animals",
  nautical: "nautical",
  clothesAndFootwears: "clothes-and-footwears",
  informatics: "informatics",
  things: "things",
  sportsAndEquipments: "sports-and-equipments",
  services: "services",
  mobilePhones: "mobile-phones",
  audioVideosPhotos: "audio-videos-photos",
  other: "other",
  childrenWorld: "children-world",
  domesticProducts: "domestic-products"
};

export const ModuleNameHr = {
  vehicles: "auto-moto",
  realEstate: "nekretnine",
  tourism: "turizam",
  jobs: "poslovi",
  machinesAndTools: "strojevi-alati",
  allForHome: "sve-za-dom",
  animals: "zivotinje",
  nautical: "nautika",
  clothesAndFootwears: "odjeca-obuca",
  informatics: "informatika",
  things: "stvari",
  sportsAndEquipments: "sport",
  services: "usluge",
  mobilePhones: "mobiteli",
  audioVideosPhotos: "audio-video-foto",
  other: "ostalo",
  childrenWorld: "djecji-svijet",
  domesticProducts: "domaci-proizvodi"
};

export const CategoryNameHr = { //TODO: Davor > finish translation
  car: "osobni-automobili",
  motorbike: "motocikli-skuteri",
  motorhomes: "kamperi",
  commercialVehicle: "gospodarska-vozila",
  constructionVehicle: "teretna-vozila",
  trailers: "prikolice",
  buses: "bus",
  agriculturalVehicle: "poljoprivredna-vozila",
  apartmentsRoomsHouses: "apartmani-sobe-kuce",
  housesForSale: "prodaja-kuca",
  flatsForSale: "prodaja-stanova",
  housesForRent: "najam-kuca",
  flatsForRent: "najam-stanova",
  roomsForRent: "najam-soba",
  jobs: "poslovi",
  newBuild: "novogradnja",
  otherProperties: "ostalo",
  studentAccommodation: "domski-studentski-smjestaj",
  retirementAccommodation: "umirovljenicki-smjestaj",
  landsForSale: "prodaja-zemljista",
  landsForRent: "najam-zemljista",
  businessSpacesForSale: "prodaja-poslovnih-prostora",
  holidayPropertiesForSale: "prodaja-nekretnina-za-odmor",
  garagesForSale: "prodaja-garaza",
  businessSpaceForRent: "najam-poslovnih-prostora",
  businessSpaceForSale: "prodaja-poslovnih-prostora",
  bikesAndScooters: "motocikli-skuteri",
  partsAndExtras: "dijelovi-dodaci",
  vessels: "plovila",
  marineEngines: "brodski-motori",
  agricultureMachines: "poljoprivredni",
  constructionMachines: "gradjevinski",
  furniture: "namjestaj",
  petsForSale: "ljubimci-na-prodaju",
};

export const CategoryName = {
  car: "car",
  motorbike: "motorbike",
  commercialVehicle: "commercial-vehicle",
  trailers: "trailers",
  buses: "buses",
  agriculturalVehicle: "agricultural-vehicle",
  oldtimers: "oldtimers",
  motorhomes: "motorhomes",
  equipmentAndSpareParts: "equipment-and-spare-parts",
  flatsForSale: "flats-for-sale",
  flatsForRent: "flats-for-rent",
  housesForSale: "houses-for-sale",
  housesForRent: "houses-for-rent",
  landsForSale: "lands-for-sale",
  landsForRent: "lands-for-rent",
  businessSpacesForSale: "business-spaces-for-sale",
  businessSpacesForRent: "business-spaces-for-rent",
  holidayProperties: "holiday-properties",
  studentAccommodation: "student-accommodation",
  garagesForSale: "garages-for-sale",
  garagesForRent: "garages-for-rent",
  roomsForRent: "rooms-for-rent",
  newBuild: "new-build",
  retirementAccommodation: "retirement-accommodation",
  otherProperties: "other-properties",
  parkingPlacesForSale: "parking-places-for-sale",
  parkingPlacesForRent: "parking-places-for-rent",
  apartmentsRoomsHouses: "apartments-rooms-houses",
  job: "job",
  agriculturalMachines: "agricultural-machines",
  constructionMachineryAndTools: "construction-machinery-and-tools",
  forkliftsPlatformsAndEquipmentForHeightWork:
    "forklifts-platforms-and-equipment-for-height-work",
  machineryAndToolsForCommunalServices:
    "machinery-and-tools-for-communal-services",
  machiningMachinesAndTools: "machining-machines-and-tools",
  forestryMachineryAndEquipment: "forestry-machinery-and-equipment",
  measuringInstruments: "measuring-instruments",
  electricalAppliancesAndTools: "electrical-appliances-and-tools",
  handTools: "hand-tools",
  cateringAndCommercialEquipment: "catering-and-commercial-equipment",
  electronicDevicesAndApparatus: "electronic-devices-and-apparatus",
  stoneProcessingMachinesAndTools: "stone-processing-machines-and-tools",
  industrialCleaningMachines: "industrial-cleaning-machines",
  otherMachinesAndTools: "other-machines-and-tools",
  homeDecoration: "home-decoration",
  constructionAndEquipping: "construction-and-equipping",
  heatingAndCooling: "heating-and-cooling",
  householdTextile: "household-textile",
  householdAppliances: "household-appliances",
  dishesAndCookingUtensils: "dishes-and-cooking-utensils",
  lighting: "lighting",
  furniture: "furniture",
  securityAtHome: "security-at-home",
  allForGardenAndBalcony: "all-for-garden-and-balcony",
  carpets: "carpets",
  theRestRelatedToTheHome: "the-rest-related-to-the-home",
  domesticAnimals: "domestic-animals",
  petsForSale: "pets-for-sale",
  missedLostAndFound: "missed-lost-and-found",
  equipmentAndAccessories: "equipment-and-accessories",
  meals: "meals",
  dominationAndGiving: "domination-and-giving",
  veterinariansWalkersAndRelatedServices:
    "veterinarians-walkers-and-related-services",
  matingAnimals: "mating-animals",
  theRestOfTheAnimals: "the-rest-of-the-animals",
  shipEngines: "ship-engines",
  charter: "charter",
  boats: "boats",
  shipSpareParts: "ship-spare-parts",
  nauticalEquipment: "nautical-equipment",
  boatTrailer: "boat-trailer",
  otherRelatedToNautika: "other-related-to-nautika",
  jewelry: "jewelry",
  glasses: "glasses",
  footwear: "footwear",
  apparel: "apparel",
  watches: "watches",
  bagsAndWallets: "bags-and-wallets",
  theRestRelatedToClothingAndStyle: "the-rest-related-to-clothing-and-style",
  fashionAccessories: "fashion-accessories",
  allForSewing: "all-for-sewing",
  domesticSoftware: "domestic-software",
  mac: "mac",
  gamesAndGameConsoles: "games-and-game-consoles",
  memoriesAndReaders: "memories-and-readers",
  networkEquipment: "network-equipment",
  pcComputersAndComponents: "pc-computers-and-components",
  printersScannersAndPhotocopiers: "printers-scanners-and-photocopiers",
  laptops: "laptops",
  softwareAndProfessionalPrograms: "software-and-professional-programs",
  usbPortableMemoryAndDevices: "usb-portable-memory-and-devices",
  wiFiWirelessEquipment: "wi-fi-wireless-equipment",
  otherItEquipment: "other-it-equipment",
  miceKeyboardsAndTheLike: "mice-keyboards-and-the-like",
  monitors: "monitors",
  tabletComputer: "tablet-computer",
  webPages: "web-pages",
  musicalInstrumentsAndEquipment: "musical-instruments-and-equipment",
  lostAndFound: "lost-and-found",
  literature: "literature",
  beauty: "beauty",
  materialsAndEquipmentForArt: "materials-and-equipment-for-art",
  medicalEquipmentAndSupplies: "medical-equipment-and-supplies",
  hairSalonEquipment: "hair-salon-equipment",
  oldAndValuable: "old-and-valuable",
  officeEquipment: "office-equipment",
  amusingApparatus: "amusing-apparatus",
  fun: "fun",
  health: "health",
  otherThings: "other-things",
  safetyAtWork: "safety-at-work",
  airsoftAndPaintballEquipment: "airsoft-and-paintball-equipment",
  bicyclesAndCyclingEquipment: "bicycles-and-cycling-equipment",
  nutritionSupplementsAndExerciseEquipment:
    "nutrition-supplements-and-exercise-equipment",
  equipmentForAlpinismAndHiking: "equipment-for-alpinism-and-hiking",
  equipmentForMartialArts: "equipment-for-martial-arts",
  campingEquipment: "camping-equipment",
  equipmentForSportsAndFitness: "equipment-for-sports-and-fitness",
  weaponsAndHuntingEquipment: "weapons-and-hunting-equipment",
  otherThingsRelatedToSportAndLeisure:
    "other-things-related-to-sport-and-leisure",
  rollingRolesAndEquipment: "rolling-roles-and-equipment",
  equipmentForTennis: "equipment-for-tennis",
  equipmentForWaterSports: "equipment-for-water-sports",
  equipmentForWinterSports: "equipment-for-winter-sports",
  footballAndSoccerEquipment: "football-and-soccer-equipment",
  fishingGearAndEquipment: "fishing-gear-and-equipment",
  sportsJerseysAndTheLike: "sports-jerseys-and-the-like",
  designPhotographyAndIntellectualService:
    "design-photography-and-intellectual-service",
  beautyAndHealth: "beauty-and-health",
  craftsAndConstruction: "crafts-and-construction",
  teachingAndInstruction: "teaching-and-instruction",
  celebrationsAndEventOrganization: "celebrations-and-event-organization",
  servicingServices: "servicing-services",
  allForWeddingsAndTheLike: "all-for-weddings-and-the-like",
  homeAndHomeRelatedServices: "home-and-home-related-services",
  otherServices: "other-services",
  rentingAVehicle: "renting-a-vehicle",
  translationServices: "translation-services",
  alcatel: "alcatel",
  blackberry: "blackberry",
  fixedTelephones: "fixed-telephones",
  htc: "htc",
  huawei: "huawei",
  xiaomi: "xiaomi",
  iphone: "iphone",
  lenovoCellPhones: "lenovo-cell-phones",
  lgCellPhones: "lg-cell-phones",
  microsoftMobilePhones: "microsoft-mobile-phones",
  motorola: "motorola",
  nexus: "nexus",
  nokiaMobilePhones: "nokia-mobile-phones",
  prestigio: "prestigio",
  samsungMobilePhones: "samsung-mobile-phones",
  siemensCellPhones: "siemens-cell-phones",
  sonyEricssonMobilePhones: "sony-ericsson-mobile-phones",
  sonyMobilePhones: "sony-mobile-phones",
  zteMobilePhones: "zte-mobile-phones",
  otherCellPhones: "other-cell-phones",
  equipmentAndPartsForMobilePhones: "equipment-and-parts-for-mobile-phones",
  theRestRelatedToCellPhones: "the-rest-related-to-cell-phones",
  tvVideoAndSatelliteEquipment: "tv-video-and-satellite-equipment",
  photo: "photo",
  navigationAndVehicleAcoustics: "navigation-and-vehicle-acoustics",
  mp3Mp4IpodPlayersAndAccessories: "mp3-mp4-ipod-players-and-accessories",
  radioStationsAndRadioAmateurEquipment:
    "radio-stations-and-radio-amateur-equipment",
  audioComponentsAndEquipment: "audio-components-and-equipment",
  othersForAudioAndVideo: "others-for-audio-and-video",
  tombs: "tombs",
  forage: "forage",
  tickets: "tickets",
  other: "other",
  modelingAndMaketarstvo: "modeling-and-maketarstvo",
  collectivePassion: "collective-passion",
  events: "events",
  babyRobes: "baby-robes",
  toysAndEquipmentForChildren: "toys-and-equipment-for-children",
  flowers: "flowers",
  mushroomsFruitsAndSeeds: "mushrooms-fruits-and-seeds",
  breadAndConfectionery: "bread-and-confectionery",
  honeyAndHoneyProducts: "honey-and-honey-products",
  meatAndMeatProducts: "meat-and-meat-products",
  dairyProducts: "dairy-products",
  vegetablesAndFruits: "vegetables-and-fruits",
  fruitAndVegetableProducts: "fruit-and-vegetable-products",
  oilAndVinegar: "oil-and-vinegar",
  domesticProductsAndVariety: "domestic-products-and-variety"
};

export const ElementId = {
  root: "root"
};

export const StyleProperty = {
  overflowY: "overflow-y",
  height: "height"
};

export const CurrentPage = {
  home: "home",
  search: "search",
  details: "details",
  myAds: "myAds",
  myRatings: "myRatings",
  module: "module"
};

export const emptyUUID = "00000000-0000-0000-0000-000000000000";
// Croatia country ID — duplicated as file-local const in many files
// (LocationSelector, MultiLevelValidator, useTags, etc.). Reference from here.
export const HrCountryId = "1d0ed9f8-c5b3-47f8-8ca1-7feb948d5aef";
// Not a real location: agreed value understood by the search API in includeCountryIds
// meaning "ads with a country other than Croatia". Returned by configuration/locations/popular.
export const NoneHrCountryId = "a05b10df-9a08-477f-a939-27e4b8ec661e";
// "Grad Zagreb" county; its children are city districts rather than cities.
export const ZagrebCountyId = "056b6c84-e6f1-433f-8bdc-9b8dbb86d6fb";
export const isCountryFilterId = (id: string) => id === HrCountryId || id === NoneHrCountryId;

export const UploadStatus = {
  done: "done",
  uploading: "uploading",
  error: "error"
};


export const VideoService = {
  vimeo: "vimeo",
  youtube: "youtube"
};


export const ImageSizeEnum = {
  cardLarge: "card_large",
  cardMedium: "card_medium",
  adLarge: "ad_large",
  adMedium: "ad_medium",
  avatarSmall: "avatar_small",
};

export const LinkTargetEnum = {
  blank: "_blank",
  self: "_self"
};

export const photoEditAction = {
  rotateLeft: "rotate-left",
  rotateRight: "rotate-right",
  flipHorizontal: "flip-horizontal",
  flipVertical: "flip-vertical",
  reset: "reset"
};

export const countryPhonePrefixes = [
  "+385", "00385",
  "+386", "00386",
  "+387", "00387",
  "+381", "00381",
  "+49", "0049",
]

export const homePhonePrefixes = [
  "01", "020", "021", "022", "023", "031", "032", "033", "034", "035", "040", "042", "043", "044", "047", "048", "049", "051", "052", "053",
]

export const mobilePhonePrefixes = [
  "091", "092", "095", "097", "098", "099",
]

// User Rating System
export const UserRatingType = {
  sellerRating: 1,
  buyerRating: 2
};

export interface UserRatingTypeTextInterface {
  name: string;
  value: number;
}

export const UserRatingTypeText: UserRatingTypeTextInterface[] = [
  { name: "Ocjena prodavača", value: UserRatingType.sellerRating },
  { name: "Ocjena kupca", value: UserRatingType.buyerRating }
];


export const UserRatingStatus = {
  notReviewed: 0,
  approved: 1,
  rejected: 2
};

export interface UserRatingStatusTextInterface {
  name: string;
  value: number;
}

export const UserRatingStatusText: UserRatingStatusTextInterface[] = [
  { name: "Nepregledano", value: UserRatingStatus.notReviewed },
  { name: "Odobreno", value: UserRatingStatus.approved },
  { name: "Odbijeno", value: UserRatingStatus.rejected }
];

export interface RatingEligibilityAd {
  adId: string;
  chatId: string;
  adTitle: string;
  userRatingType: number; // UserRatingType enum
}

export interface CreateUserRatingRequest {
  chatId: string;
  type: number; // UserRatingType enum
  adDescriptionAccuracy?: number; // 1-5 star rating (seller rating only - "Opis oglasa")
  paymentAndExchangeAgreement?: number; // 1-5 star rating (buyer rating only - "Plaćanje / zamjena")
  communication: number; // 1-5 star rating
  honoringAgreement: number; // 1-5 star rating
  comment: string;
}

export interface UserRatingAnswerRequest {
  userRatingId: string;
  answerComment: string;
}

export interface UserRating {
  id: string;
  adTitle: string;
  username: string;
  avatar?: string;
  type: number; // UserRatingType enum
  createdAt: string;
  adDescriptionAccuracy?: number; // 1-5 star rating (seller rating only - "Opis oglasa")
  paymentAndExchangeAgreement?: number; // 1-5 star rating (buyer rating only - "Plaćanje / zamjena")
  communication: number; // 1-5 star rating
  honoringAgreement: number; // 1-5 star rating
  overallRating: number; // Calculated average (double)
  comment: string;
  answerComment?: string;
  canAnswerToComment: boolean;
}

export interface UserRatingList {
  data: UserRating[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
}

export interface UserRatingOverallCount {
  totalCount: number;
  averageRating: number | null;
}

export interface AdminUserRating {
  id: string;
  chatId: string;
  createdAt: string;
  code: string;
  ratedByEmail: string;
  ratedById: string;
  userEmail: string;
  userId: string;
  status: number; // UserRatingStatus enum
  type: number; // UserRatingType enum
  adDescriptionAccuracy?: number; // 1-5 star rating (seller rating only - "Opis oglasa")
  paymentAndExchangeAgreement?: number; // 1-5 star rating (buyer rating only - "Plaćanje / zamjena")
  communication: number; // 1-5 star rating
  honoringAgreement: number; // 1-5 star rating
  overallRating: number; // Calculated average (double)
  comment: string;
}

export interface AdminUserRatingList {
  data: AdminUserRating[];
  count: number;
  page: number;
  nextPage: number;
  previousPage: number;
  currentPage: number;
}

export interface SetUserRatingStatusRequest {
  status: number; // UserRatingStatus enum
}
export const mobilePhonePrefixesAbroad = [
  "060", "061", "062", "063", "064", "065", "066", "069",
]

export const SystemMessageUserGroup = {
  AllUsers: 1,
  ActiveXMLUsers: 2,
  LegalEntityUser: 3,
  NonLegalEntityUsers: 4,
  ByUsername: 5,
  AdInCategory: 6,
};

export const SystemMessageUserGroupText = [
  { value: SystemMessageUserGroup.AllUsers, name: "Svi korisnici" },
  { value: SystemMessageUserGroup.ActiveXMLUsers, name: "Aktivni XML korisnici" },
  { value: SystemMessageUserGroup.LegalEntityUser, name: "Pravne osobe" },
  { value: SystemMessageUserGroup.NonLegalEntityUsers, name: "Fizičke osobe" },
  { value: SystemMessageUserGroup.ByUsername, name: "Po korisničkom imenu" },
  { value: SystemMessageUserGroup.AdInCategory, name: "Aktivni oglasi u kategoriji" },
];

export const SystemMessageType = {
  Normal: 1,
  PromptChoice: 2,
};

export const SystemMessageTypeText = [
  { value: SystemMessageType.Normal, name: "Normalna poruka" },
  { value: SystemMessageType.PromptChoice, name: "Da/Ne poruka" },
];

export const SystemMessageStatus = {
  Sending: 0,
  Sent: 1,
};

export const SystemMessageStatusText = [
  { value: SystemMessageStatus.Sending, name: "Šalje se" },
  { value: SystemMessageStatus.Sent, name: "Poslano" },
];


export const RentPriceType = {
  Monthly: 1,
  Daily: 2
}


export const RentPriceTypeValues = {
  [RentPriceType.Monthly]: "mjesec",
  [RentPriceType.Daily]: "dan",
}

export const PriceType = {
  Total: 1,
  PerM2: 2
}


export const PriceTypeValues = {
  [PriceType.Total]: "",
  [PriceType.PerM2]: "m²",
}



// WEBPACK FOOTER //
// ./src/models/enums.ts